import { TBrand, UserModel } from "@cakemail-org/ui-components-v2"
import { TBeeEditorContentContext } from "../types"


export function getContentDefaults({ userBrand, getContentContext }: { userBrand: TBrand & any, getContentContext: () => TBeeEditorContentContext }) {
    let defaultContent: any = {

    }

    const templateStyles = userBrand?.smart_email_templates?.styles || {}

    if (!templateStyles) return defaultContent

    const headlineColor = templateStyles?.headline_text_color || undefined
    const linkColor = templateStyles?.link_color
    const textColor = templateStyles?.p_text_color
    const btnTxtColor = templateStyles?.button_text_color
    const btnBGColor = templateStyles?.button_bg_color

    defaultContent = {
        ...defaultContent,
        defaultColors: [headlineColor, linkColor, textColor, btnBGColor, btnTxtColor],
        titleDefaultStyles: {
            h1: {
                color: headlineColor,
            },
            h2: {
                color: headlineColor,
            },
            h3: {
                color: headlineColor,
            },
        },
        contentDefaults: {
            text: {
                styles: {
                    color: textColor,
                    linkColor,
                }
            },

            button: {
                styles: {
                    color: btnTxtColor,
                    backgroundColor: btnBGColor
                },
            },
            menu: {
                styles: {
                    color: textColor,
                    linkColor,
                },
            },

            paragraph: {
                styles: {
                    color: textColor,
                    linkColor,
                }
            },


            list: {
                styles: {
                    color: textColor,
                    linkColor
                },
            },

            table: {
                styles: {
                    color: textColor,
                    linkColor
                },
            },

            general: {
                linkColor
            },

        }
    }

    return defaultContent
}